import { Avatar, Box, Button, InputBase, Link, List, ListItem, ListItemText, Paper, Typography, Zoom } from "@material-ui/core";
import { Business, Send } from "@material-ui/icons";
import React from "react";
import { Link as RouterLink } from 'react-router-dom';

import { Collections } from "Collections";
import { useAppUser } from "components/AppUserProvider";
import { FullscreenLoading } from "components/FullscreenLoading";
import { PageNavigation } from "components/PageNavigation";
import { FirebaseUtils } from "firebaseUtils/FirebaseUtils";
import { AnalyticsEvent } from "models/AnalyticsEvent";
import { AppUser, noAppUserNameText } from "models/AppUser";
import { noOrgNameText, Org } from "models/Org";
import { Paths } from "Paths";
import { dateFormat } from "Util/date.utils";

import { EmptyPage } from "./EmptyPage";

type Props = {
    id?: string
}

export function OrgScreen({ id }: Props) {
    const [appUserDoc, loadingAppUser] = useAppUser()
    const [orgDoc, loadingOrgDoc] = FirebaseUtils.useDocumentData<Org>(
        true,
        Collections.ORGS,
        id || null,
        AnalyticsEvent.GET_ORG_ERROR,
        {},
    )
    const org = orgDoc?.data || null
    const [orgOwnerDoc, loadingOrgOwnerDoc] = FirebaseUtils.useDocumentData<AppUser>(
        true,
        Collections.APP_USERS,
        org?.owner.appUser?.id || null,
        AnalyticsEvent.GET_APP_USER_ERROR,
        {},
    )
    const orgOwner = orgOwnerDoc?.data || org?.owner.appUser || null
    const appUser = appUserDoc?.data || null

    const loading = loadingAppUser || loadingOrgDoc || loadingOrgOwnerDoc

    if (!loading && !appUser) {
        return <EmptyPage text="Fant ikke Organisasjonen" />
    }

    const content = loading ? <FullscreenLoading screenId="Org" /> : (
        (!org || !orgDoc) ? (
            <List>
                <ListItem>
                    <ListItemText primary="Kunne ikke finne brukeren" />
                </ListItem>
            </List>
        ) : (
            <List>
                <ListItem>
                    <Box mx="auto" mt="40px">
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Paper
                                elevation={3}
                                style={{
                                    position: 'relative',
                                    //width: 300,
                                    //height: 300,
                                    borderRadius: 18,
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <Avatar
                                    style={{ width: 120, height: 120, marginTop: -40 }}
                                    alt="Org Logo"
                                    src={org.logo?.original.url || undefined}
                                >
                                    <Business />
                                </Avatar>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                        marginTop: 18,
                                        marginBottom: 18,
                                    }}
                                >
                                    <InputBase
                                        value={noOrgNameText(org.name?.text)}
                                        disabled
                                        inputProps={{
                                            'aria-label': 'org name input',
                                            style: {
                                                fontSize: 26,
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                            },
                                        }}
                                    />
                                    <Typography variant="h6">
                                        <Link component={RouterLink} to={Paths.APP_USERS + '/' + org.owner.appUser?.id}>
                                            {noAppUserNameText(orgOwner?.contactInfo?.name?.fullName)}
                                        </Link>
                                    </Typography>
                                    <Typography variant="subtitle2">Opprettet: {dateFormat.format(orgDoc.metadata.createdAt.toDate())}</Typography>
                                </div>
                                <Zoom in>
                                    <div>
                                        {(org && appUser && orgOwner?.contactInfo?.email?.email) ? (
                                            <Button
                                                size="medium"
                                                style={{ marginBottom: -20 }}
                                                color="primary"
                                                component="a"
                                                href={`mailto:${orgOwner.contactInfo?.email?.email}?subject=Forespørsel om invitasjon&body=Jeg ønsker å bli med i organisasjonen din. Her er en link til min AppBruker: ${window.location.origin + Paths.APP_USERS + '/' + appUser.id}`}
                                                aria-label="request invite"
                                                variant="contained"
                                                endIcon={<Send />}
                                            >
                                                Be om invitasjon
                                            </Button>
                                        ) : null}
                                    </div>
                                </Zoom>
                            </Paper>
                        </div>
                    </Box>
                </ListItem>
            </List >
        )
    )

    return (
        <PageNavigation title="Organisasjon" backHistoryButton>
            {content}
        </PageNavigation>
    )
}